import { keyBy, mapValues } from 'lodash/fp';

import { BaseResource } from '../types';

type NamedItem = Pick<BaseResource, 'id' | 'name'>;

export const getNamesById = (items: NamedItem[] | null | undefined): Record<number, string> =>
    mapValues('name', keyBy('id', items ?? []));
